import {
  getErrorMsgAndCode,
  compressImage,
  validateInput,
} from "./FrontendHelpers";
import api from "./axios";

const checkInput = (ID, Name, Address) => {
  return validateInput([
    { Name: "ID", Value: ID, Type: "warehouseID", MaxLengthType: "id" },
    {
      Name: "Name",
      Value: Name,
      Type: "string",
      MinLength: 1,
      MaxLengthType: "name",
    },
    {
      Name: "Address",
      Value: Address,
      Type: "string",
      MinLength: 0,
      MaxLengthType: "detail",
      OnlyCheckLength: true,
    },
  ]);
};

export async function GetWarehouses() {
  try {
    const response = await api.get("/getWarehouses");
    return [response.data, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetWarehouseMap() {
  try {
    const response = await api.get("/getWarehouseMap");
    const result = response.data;
    const warehouseMap = new Map(result);
    return [warehouseMap, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function CreateWarehouse(image, Name, ID, Address) {
  try {
    const data = new FormData();

    const errorObj = checkInput(ID, Name, Address);
    if (errorObj.errCode !== 0) return [null, errorObj];

    if (image) {
      try {
        const compressedFile = await compressImage(image);
        data.append("image", compressedFile, compressedFile.name);
      } catch (error) {
        const errorObj2 = getErrorMsgAndCode(error);
        return [null, errorObj2];
      }
    }

    data.append("Name", Name);
    data.append("ID", ID);
    if (Address) data.append("Address", Address);

    const response = await api.post("/createWarehouse", data);

    return [response.data, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function EditWarehouse(image, Name, ID, Address, CurrentID) {
  try {
    const data = new FormData();

    const errorObj = checkInput(ID, Name, Address);
    if (errorObj.errCode !== 0) return [null, errorObj];

    if (image) {
      try {
        const compressedFile = await compressImage(image);
        data.append("image", compressedFile, compressedFile.name);
      } catch (error) {
        const imgError = getErrorMsgAndCode(error);
        return [null, imgError];
      }
    }

    data.append("Name", Name);
    data.append("ID", ID);
    if (Address) data.append("Address", Address);
    data.append("CurrentID", CurrentID);

    const response = await api.post("/editWarehouse", data);

    return [response.data, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetWarehouseData(argument, bywhat = "WarehouseID") {
  try {
    const data = { Argument: argument, byWhat: bywhat };
    const response = await api.post("/getWarehouseInfo", data);
    const info = response.data;
    return [info[0], null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function DeleteWarehouse(id) {
  try {
    const data = { ID: id };
    await api.post("/deleteWarehouse", data);

    return [null, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
export async function CheckForWarehouse(id) {
  try {
    const data = { ID: id };

    const response = await api.post("/checkForWarehouse", data);
    const info = response.data;
    if (info[0]) {
      return [true, null];
    }

    return [false, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

//Gets the next available 4 digit ID for a warehouse
export async function GetNextWarehouseID() {
  try {
    const response = await api.get("/getNextWarehouseID");
    const data = response.data;
    return [data.nextID, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

//Get number of existing warehouses
export async function GetWarehouseCount() {
  try {
    const response = await api.get("/getWarehouseCount");
    const data = response.data;
    return [data.count, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
